module.exports = __webpack_public_path__ + "static/media/print.84d9c957.svg";